import { FC, ReactNode } from 'react';
import styles from './CardGrid.module.scss';

export interface CardGridProps {
  children: ReactNode;
  className?: string;
}

export const CardGrid: FC<CardGridProps> = ({ children, className }) => (
  <div className={`${styles.cardGrid} ${className || ''}`}>
    {children}
  </div>
);
